import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory as history, Link } from 'react-router';
import AssignmentIcon from '@material-ui/icons/Assignment';

import SelectTable from '../../../../components/v3/CalibrationScreenV3/SelectTable';
import AgentAuditsSummary from '../manager/coach/AgentAuditsSummary';

import {
    loadQaDashboardAgentScreen,
    loadAgentCompletedAuditsDetails,
    loadAgentTeamQaScore,
    updateProps
} from '../QaDashboardScreenActions';
import { colors } from '../../../../constants';
import { arrayIsNotEmpty, pageLoaded } from '../../../../utils';

class QaDashboardAgentScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSelectQaSurveyFormPopup: false,
        };

        this.getCompletedAuditsDetailsNode = this.getCompletedAuditsDetailsNode.bind(this);
        this.getTimeRangesNode = this.getSelectQaSurveyFormNode.bind(this);
        this.showSelectQaSurveyFormPopup = this.showSelectQaSurveyFormPopup.bind(this);
        this.hideSelectQaSurveyFormPopup = this.hideSelectQaSurveyFormPopup.bind(this);
    }

    showSelectQaSurveyFormPopup() {
        this.setState({ showSelectQaSurveyFormPopup: true });
    }

    hideSelectQaSurveyFormPopup(selectedSurveyForm) {
        const
            {
                currentUser,
                qaSurveyforms,
                selectedQaSurveyform
            } = this.props;
        this.setState({ showSelectQaSurveyFormPopup: false });

        if (arrayIsNotEmpty(selectedSurveyForm) && selectedQaSurveyform.id !== selectedSurveyForm[0].id) {
            const selected = qaSurveyforms.find(qa => qa.id == selectedSurveyForm[0].id);

            //// wipe the old data
            this.props.dispatch(updateProps({
                selectedQaSurveyform: selected,
                currentAgentCompletedAuditsDetails: undefined
            }));


            //// Get new data
            this.props.dispatch(loadAgentCompletedAuditsDetails(currentUser.Id, selected.id));
            this.props.dispatch(loadAgentTeamQaScore(currentUser.Id, selected.id));
        }
    }

    getSelectQaSurveyFormNode() {
        const {
            selectedQaSurveyform
        } = this.props;

        const surveyName = selectedQaSurveyform ? selectedQaSurveyform.name : '';
        return (
            <div className="flex-container" style={{ margin: '24px 0' }}>
                <div>
                    <div className="title-primary-400-24-28" style={{ margin: '0 0 4px -5px' }}>
                        <AssignmentIcon style={{ margin: '0 3px -3px 0', color: colors.primary200 }} />
                        <span style={{ color: '#FF7700' }}>{surveyName}</span>
                    </div>
                    <div className="title-secandary-400-12-14 cursor-pointer"
                        onClick={this.showSelectQaSurveyFormPopup} >Select another Survey Form</div>
                </div>
                {/*
                <div className="flex-container-start">
                    <div style={{ margin: '0 0 0 20px' }}>
                        <DateRangePicker
                            fromDate={this.state.fromDate}
                            toDate={this.state.toDate}
                            onClose={this.onSelectNewTimeRange} />
                    </div>
                </div>
                */ }
            </div>);
    }

    getCompletedAuditsDetailsNode() {
        const
            {
                currentUser,
                selectedQaSurveyform,
                currentAgentCompletedAuditsDetails,
            } = this.props;

        const selectedAgentToCoach = { agentName: currentUser ? currentUser.Name : '' };

        return <div>
            <AgentAuditsSummary
                selectedAgentToCoach={selectedAgentToCoach}
                selectedQaSurveyform={selectedQaSurveyform}
                completedAuditsDetails={currentAgentCompletedAuditsDetails} />
        </div>
    }

    componentDidMount() {
        const
            {

            } = this.props;
        pageLoaded('QA');
        this.props.dispatch(loadQaDashboardAgentScreen());
    }

    getSelectQaSurveyFormPopup() {
        const
            {
                qaSurveyforms,
            } = this.props;

        if (!qaSurveyforms)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-qaForms">
                <SelectTable
                    title="Select a survey form:"
                    searchPlaceHolder="Search..."
                    options={qaSurveyforms}
                    onClose={this.hideSelectQaSurveyFormPopup} />
            </div>
        </div>);
    }

    render() {


        const selectQaSurveyFormNode = this.getSelectQaSurveyFormNode();
        const selectQaSurveyFormPopup = this.state.showSelectQaSurveyFormPopup ? this.getSelectQaSurveyFormPopup() : undefined;
        let completedAuditsDetailsNode = this.getCompletedAuditsDetailsNode();

        return <div className="main-page-width">
            {selectQaSurveyFormNode}
            {selectQaSurveyFormPopup}
            {completedAuditsDetailsNode}
        </div>
    }
}

const select = state => ({ ...state.session, ...state.QaDashboardManagerScreen });

export default connect(select)(QaDashboardAgentScreen);